import Button from "@/shared/form/button";
import { Errors } from "@/shared/graphql";
import Text from "@/shared/typography/text";
import { ReactNode } from "react";
import {
  ErrorBoundary as CoreErrorBoundary,
  FallbackProps,
} from "react-error-boundary";
import { BackendErrorRedirect } from "./backend-error-redirect/backend-error-redirect";
import { SIGN_IN_PATH } from "@/modules/auth/pages/sign-in";
import { isStaleBuildError } from "@/application/stale-build/is-stale-build-error";
import { reloadOnce } from "@/application/stale-build/reload-once";

export default function ErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <BackendErrorRedirect>
      <CoreErrorBoundary FallbackComponent={ErrorFallback}>
        {children}
      </CoreErrorBoundary>
    </BackendErrorRedirect>
  );
}

function ErrorFallback({ error }: FallbackProps) {
  if (error.message === Errors.UNAUTHORIZED) {
    window.location.href = SIGN_IN_PATH;
    return null;
  }

  if (isStaleBuildError(error) && reloadOnce()) {
    return null;
  }

  return <SomethingWentWrong />;
}

export function SomethingWentWrong({
  message,
  onClick,
}: {
  message?: string | null;
  onClick?: () => void;
}) {
  const defaultOnClick = () => window.location.reload();

  return (
    <div className="w-screen h-screen flex justify-center items-center flex-col">
      <div className="max-w-[700px] flex flex-col justify-center items-center">
        <Text type="headline1" className="text-center">
          {message ?? "Something went wrong!"}
        </Text>
        <div className="mt-3">
          <Button onClick={onClick ?? defaultOnClick}>Reload</Button>
        </div>
      </div>
    </div>
  );
}
